import type { DecorAlternativesFilter } from '@pomoshnik/shared';

/**
 * Хелперы протяжки активного фильтра декора через URL (ADR-0055).
 *
 * Цепочка каталог/подбор → карточка → альтернативы несёт `subcategories/brands/
 * types` в query, чтобы экран альтернатив подал их в `apiClient.decors.alternatives`.
 * R3: эти параметры — **persistent intent** (bookmark-able, «Назад» восстанавливает
 * отфильтрованный контекст), не transient-сигналы.
 *
 * Не-компонентный модуль (react-refresh не любит value-export рядом с компонентом),
 * рядом с `decorFilterFields.ts`.
 */
export interface DecorFilterParams {
  subcategories: string[];
  brands: string[];
  types: string[];
}

/** Читает фильтр из URLSearchParams (повтор ключа, как useCatalogFilters). */
export function readDecorFilterParams(sp: URLSearchParams): DecorFilterParams {
  return {
    subcategories: sp.getAll('subcategories'),
    brands: sp.getAll('brands'),
    types: sp.getAll('types'),
  };
}

/** `?subcategories=..&brands=..&types=..` (без ведущего `?`); пусто → ''. */
export function decorFilterToQuery(f: DecorFilterParams): string {
  const p = new URLSearchParams();
  for (const v of f.subcategories) p.append('subcategories', v);
  for (const v of f.brands) p.append('brands', v);
  for (const v of f.types) p.append('types', v);
  return p.toString();
}

export function hasDecorFilter(f: DecorFilterParams): boolean {
  return f.subcategories.length + f.brands.length + f.types.length > 0;
}

/** Для typed-client `alternatives(...,filter)` — undefined-поля при пустых массивах. */
export function toAlternativesFilter(f: DecorFilterParams): DecorAlternativesFilter {
  return {
    subcategories: f.subcategories.length > 0 ? f.subcategories : undefined,
    brands: f.brands.length > 0 ? f.brands : undefined,
    types: f.types.length > 0 ? f.types : undefined,
  };
}
